<template>
  <div class="alert alert-info floating-feedback" v-if="message">
    <small>{{message}}</small>
  </div>
  <div class="alert alert-info floating-feedback" v-if="updating">
    <small>Updating&hellip;</small>
  </div>
  <h3>
    Colpo Review
  </h3>
  <hr>

  <div class="form-horizontal">
    <div class="form-group">
      <label for="filter" class="control-label col-sm-1"><strong>Filter:</strong></label>
      <div class="col-sm-3">
        <input type="text" id="filter" class="form-control" v-model="searchTerm" placeholder="Type to Search"/>
      </div>
    </div>
  </div>

  <table class="table table-striped" id="colpo-table">
    <thead>
      <tr>
        <th @click="setSortBy('ccs_id')">
          CCS ID
        </th>
        <th @click="setSortBy('full_name')">
          Name
        </th>
        <th @click="setSortBy('last_exam')">
          Last Exam
        </th>
        <th @click="setSortBy('task')">
          Upcoming Task
        </th>
        <th></th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="part in sortedParticipants" :key="'participant_'+part.id">
        <td><a :href="'/participants/'+part.id">{{ part.ccs_id }}</a></td>
        <td><a :href="'/participants/'+part.id">{{ part.full_name }} ({{ part.id }})</a></td>
        <td>{{ (part.last_exam) ? part.last_exam.starts_at.format('MM/DD/YYYY') : '' }}</td>
        <td>
          <div v-if="!part.upcoming_task"></div>
          <div v-if="part.upcoming_task">
            <a :href="'/tasks/'+part.upcoming_task.id">
              {{ part.upcoming_task.task_type.name }}
            </a>
            <small v-if="part.upcoming_task.data && part.upcoming_task.task_type_id == 16" class="text-muted">
              (Window {{ part.upcoming_task.data.visit_window_id }})
            </small>
            <small class="text-muted">
              {{ part.upcoming_task.date_due.format('MM/DD/YYYY') }}
            </small>

            &nbsp;
            <button 
              type="button" 
              class="btn btn-xs btn-default" 
              title="Cancel, not needed"
              @click="cancelTask(part)">Cancel</button>
          </div>
        </td>
        <td>
          <a
            v-if="!part.upcoming_task"
            :href="'/appointments/create/?attendee_id='+part.id+'&appointment_type_id=2'"
            class="btn btn-default btn-xs"
          >
            Schedule Colpo Exam
          </a>
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script setup>
  import { ref, computed, onMounted } from 'vue'
  import VisitWindowResource from '../resources/VisitWindowResource.js';
  import ColpoResource from '../resources/ColpoResource.js';

  const visitWindows = ref([])
  const searchTerm = ref(null)
  const sortBy = ref('ccs_id')
  const sortDir = ref('asc')
  const participants = ref([])
  const message = ref(null)
  const updating = ref(true)

  const sortedParticipants = computed(() => {
    var filterFunc = function (participant) {
      if (participant.eligibility && participant.eligibility.id == 3) {
        return false;
      }
      var re = new RegExp(searchTerm.value, 'i');
      if (searchTerm.value && searchTerm.value.length > 1) {
        return (participant.full_name.search(re) != -1
            || participant.id == searchTerm
            || participant.ccs_id.search(re) != -1);
      } else {
        return true
      }
    }.bind(this);

    let direction = sortDir.value == 'asc' ?  1 : -1;
    return participants.value.filter(filterFunc)
        .sort(function (a, b) {
          let sortExam = function (a, b) {
              if (!a.last_exam) {
                return -1 * direction;
              }
              if (!b.last_exam) {
                return 1 * direction;
              }
              return a.last_exam.starts_at.diff(b.last_exam.starts_at);
            }

          let sortTask = function (a, b) {
              if (!a.upcoming_task) {
                return -1 * direction;
              }
              if (!b.upcoming_task) {
                  return 1 * direction;
              }
              return 0;
            }

            switch (sortBy.value) {
              case ('ccs_id'):
              case ('full_name'):
                if (a[sortBy.value] > b[sortBy.value]) return 1 * direction;
                if (a[sortBy.value] < b[sortBy.value]) return -1 * direction;
                return 0;
                break;
              case ('last_exam'):
                let examSort = sortExam(a, b);
                return (examSort == 0) ? sortTask(a, b) : examSort;
                break;
              default: 
                let taskSort = sortTask(a, b);
                return (taskSort == 0) ? sortExam(a, b) : taskSort;
                break;
              }
          }.bind(this));
  })

  function setSortBy(val) {
    sortBy.value = val
    sortDir.value = sortDir.value == 'asc' ? 'desc' : 'asc'
  }

  function fetchVisitWindows() {
    VisitWindowResource.all()
      .then(function (response) {
        visitWindows.value = response.data.filter(function(item){
          return moment(item.closes_at) > moment() && moment(item.closes_at) < moment().add(2.5, 'years');
        });
      }.bind(this));
    }

  function triggerMessage(msg) {
    message.value = msg;
    setTimeout(function () {
        message.value = null;
    }.bind(this), 4000)
  }

  function cancelTask(participant) {
    updating.value = true;
    ColpoResource.participants
      .cancelUpcomingTask(participant)
      .then(function (response) {
        updateParticipant(response.data);
        triggerMessage('Canceled task for '+participant.full_name+'.')
      }.bind(this));
  }

  function updateParticipant(newPartData) {
    updating.value = false;
    participants.value = participants.value.map(function (p) {
      if (p.id == newPartData.id) {
        return newPartData;
      }
      return p;
    })
  }
    
  onMounted(() => {
    fetchVisitWindows();

    ColpoResource.participants.all()
      .then(function (response) {
        participants.value = response.data;
        updating.value = false;
      }.bind(this))
      .catch(function (error) {
        alert('Failed to retrieve participant colpo data');
        console.log(error);
      });
  })
</script>

<style scoped>
  th {
    cursor: pointer;
  }
</style>